const FIRST_HOUR_DAY = 0
const LAST_HOUR_DAY = 1425

export const DEFAULT_START = 540
export const DEFAULT_END = 1080

export const roundStartHour = hour => {
  const rounded = hour - (hour % 60)
  return Math.max(FIRST_HOUR_DAY, rounded)
}

export const roundEndHour = hour => {
  const rounded = hour + (hour % 60)
  return Math.min(LAST_HOUR_DAY, rounded)
}
